import { trueTypeOf } from "./type-utils";

interface formDataFileToUpload {
  uploadFileName: string;
  file: File | null;
}

export const convertObjectToFormData = (
  objectKeysSource: object,
  objectWithValues: object,
  filesToUpload?: formDataFileToUpload[]
): FormData => {
  let formDataToPost = new FormData();
  const stateObjectKeys = Object.keys(objectKeysSource);

  stateObjectKeys.forEach((key) => {
    const value = (objectWithValues as any)[key];

    var isArrayProperty = trueTypeOf(value) === "array";

    if (isArrayProperty) {
      formDataToPost.append(`${key}[]`, value);
    } else {
      value !== null && formDataToPost.append(key, value);
    }
  });

  if (filesToUpload) {
    filesToUpload.forEach((f) => {
      f.file && formDataToPost.append(f.uploadFileName, f.file);
    });
  }

  // console.log("formDataToPost getAll(): ", formDataToPost.entries());
  // console.log("formDataToPost: ", [...(formDataToPost as any)]);

  return formDataToPost;
};
